import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { addEditServiceRequest } from "../../../commons/ServiceRequest";
import StoreContractForm from "../../../components/PMWork/MAService/StoreContractForm";
import SpecificationDetailsForm from "../../../components/PMWork/MAService/SpecsDetailsForm";
import LumsumContractForm from "../../../components/PMWork/MAService/LumsumContractForm";
import KeepPdfContsService from "../../../services/keeppdfcont.service";
import ContractSpecHdsService from "../../../services/contractspechd.service";
import ContractSpecDtsService from "../../../services/contractspecdt.service";
import ContractFocHdsService from "../../../services/contractfochd.service";
import ContractFocDtsService from "../../../services/contractfocdt.service";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";

export default function AddMAServiceContract() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { websiteName, setWebsiteName } = useWebsiteName();

  const handleSubmitKeepPdf = (data) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: KeepPdfContsService.createKeepPdfConts(data),
      navigated: (navi) => {
        if (navi) {
          navigate("/MA_service/create", { state });
          navigate(0);
        }
      }
    });
  };

  const handleSubmitSpecHds = ({ Hds, Dts }) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ContractSpecHdsService.createContractSpecHds(Hds),
      callback: ({ generatedMaps }) => {
        const Dt = {
          Array: Dts?.Array.map((item) => ({
            ...item,
            Con_Spec_Hd_Id: generatedMaps?.[0].Id
          }))
        };
        handleSubmitSpecDts(Dt);
      }
    });
  };

  const handleSubmitSpecDts = (Dts) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ContractSpecDtsService.createContractSpecDts(Dts),
      navigated: (navi) => navi && navigate(0)
    });
  };

  const handleSubmitFocHds = ({ Hds, Dts }) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ContractFocHdsService.createContractFocHds(Hds),
      callback: ({ generatedMaps }) => {
        const Dt = {
          Array: Dts?.Array.map((item) => ({
            ...item,
            Contract_Foc_Hd_Id: generatedMaps[0].Id
          }))
        };
        handleSubmitFocDts(Dt);
      }
    });
  };

  const handleSubmitFocDts = (Dts) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ContractFocDtsService.createContractFocDts(Dts),
      navigated: (navi) => navi && navigate(0)
    });
  };

  useEffect(
    () =>
      handleChangeWebsiteTab({
        key: state?.name || "contract",
        setWebsiteName,
        tabNames: {
          contract: "สัญญางานบริการ MA",
          store: "เพิ่มจัดเก็บสัญญา",
          requirements: "เพิ่มข้อกำหนดเพิ่มเติม",
          lumsum: "เพิ่มกำหนดอะไหล่ในสัญญา LUMSUM"
        }
      }),
    []
  );

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Add specification details Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs justify activeKey={state?.name}>
          <Tab eventKey="contract" title="สัญญางานบริการ MA"></Tab>
          <Tab eventKey="store" title="จัดเก็บสัญญา">
            {state?.name === "store" && (
              <StoreContractForm onSubmitCallback={handleSubmitKeepPdf} />
            )}
          </Tab>
          <Tab eventKey="requirements" title="ข้อกำหนดเพิ่มเติม">
            {state?.name === "requirements" && (
              <SpecificationDetailsForm
                onSubmitCallback={handleSubmitSpecHds}
              />
            )}
          </Tab>
          <Tab eventKey="lumsum" title="กำหนดอะไหล่ในสัญญา LUMSUM">
            {state?.name === "lumsum" && (
              <LumsumContractForm onSubmitCallback={handleSubmitFocHds} />
            )}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
